import { render, staticRenderFns } from "./sendPage.vue?vue&type=template&id=98e33824&scoped=true"
import script from "./sendPage.vue?vue&type=script&lang=js"
export * from "./sendPage.vue?vue&type=script&lang=js"
import style0 from "./sendPage.vue?vue&type=style&index=0&id=98e33824&prod&lang=css"
import style1 from "./sendPage.vue?vue&type=style&index=1&id=98e33824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e33824",
  null
  
)

export default component.exports